import * as Sentry from '@sentry/vue'
import { isEmpty } from 'lodash'

async function lazyLoadSentryIntegrations() {
  // don't load on server
  if (!process.client) return

  const { Replay } = await import('@sentry/vue')
  // Keep Sentry's Replay privacy defaults: mask all text and inputs, block all
  // media, and do not capture network request or response details.
  Sentry.addIntegration(
    new Replay({
      maskAllText: true,
      maskAllInputs: true,
      blockAllMedia: true,
    }),
  )
}

function getSentryIntegrations() {
  // don't load on server
  if (!process.client) return []

  const router = useRouter()

  return [Sentry.browserTracingIntegration({ router }), Sentry.captureConsoleIntegration()]
}

export default defineNuxtPlugin({
  name: 'sentry',
  parallel: true,
  async setup(nuxtApp) {
    const vueApp = nuxtApp.vueApp

    const {
      public: { sentry },
    } = useRuntimeConfig()

    if (isEmpty(sentry.dsn)) {
      return
    }

    Sentry.init({
      app: vueApp,
      dsn: sentry.dsn,
      integrations: getSentryIntegrations(),

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: sentry.trace_rate,

      // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
      // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

      // This sets the sample rate. You may want this to be 100% while
      // in development and sample at a lower rate in production
      replaysSessionSampleRate: sentry.replay_rate,

      // If the entire session is not sampled, use the below sample rate to sample
      // sessions when an error occurs.
      replaysOnErrorSampleRate: sentry.replay_error_rate,
    })

    // Lazy-load the replay integration to reduce bundle size
    lazyLoadSentryIntegrations()

    return {
      provide: { Sentry },
    }
  },
})
